import React from "react";
import {
    ThemeBasedColorHeader,
    ThemeBasedColorMenubar,
} from "src/shared/modules/profile/theme/themeCheacker";

export default function OrderItemsTable({ order, returnQty, setReturnQty }: any) {

    const handleQtyChange = (i: number, value: string, max: number) => {
        setReturnQty((prev: any) => ({
            ...prev,
            [i]: Math.min(Number(value), max),
        }));
    };

    const getReturnedQty = (productId: string) => {
        return (
            order?.returnHistory?.reduce((acc: number, p: { items: any[] }) => {
                return (
                    acc +
                    p.items.reduce((itemAcc: number, i: any) => {
                        return i.productId === productId
                            ? itemAcc + i.returnedQty
                            : itemAcc;
                    }, 0)
                );
            }, 0) || 0
        );
    };


    if (!order)
        return (
            <div className={`col-span-3 ${ThemeBasedColorMenubar()} rounded-xl shadow p-10 text-center text-gray-400`}>
                No Data
            </div>
        );

    return (
        <div className={`col-span-4 rounded-xl shadow p-2 border ${ThemeBasedColorMenubar()}`}>

            <h2 className="text-lg font-semibold mb-3">Order Items</h2>

            <table className="w-full text-sm">
                <thead className={`${ThemeBasedColorHeader()} text-white`}>
                    <tr>
                        {["S.No", "Product", "Price", "Qty", "Returned", "Return Qty", "Total"].map((h) => (
                            <th key={h} className="p-2">{h}</th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {order.Products.map((p: any, i: number) => {
                        const qty = returnQty[i] || "";
                        const returned = getReturnedQty(p.productId);

                        return (
                            <tr key={i} className="text-center border-b bg-white">
                                <td className="p-2">{i + 1}</td>

                                <td className="p-2">
                                    {p.productName} <br/> {p.arabicword}
                                </td>

                                <td className="p-2">{p.amount}</td>

                                <td className="p-2">
                                    {p.quantity} {p.uom}
                                </td>

                                {/* ✅ Already Returned */}
                                <td className="p-2 text-red-500 font-medium">
                                    {returned}
                                </td>

                                <td className="p-2">
                                    <input
                                        type="number"
                                        value={qty}
                                        min={0}
                                        max={p.quantity - returned}
                                        onChange={(e) =>
                                            handleQtyChange(i, e.target.value, p.quantity - returned)
                                        }
                                        placeholder="0"
                                        className="border w-16 text-center rounded placeholder:text-gray-700"
                                        disabled={p.quantity - returned === 0}
                                    />
                                </td>

                                <td className="p-2 font-medium">
                                    {(qty * p.amount).toFixed(2)}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}